export default __webpack_public_path__ + "static/media/6.54572b06.webp";